import React from "react";
import {autobind} from "core-decorators";
import {Layout} from "antd";
import {inject, observer} from "mobx-react";

import "./PageLayout.scss";
import Header from "./Header/Header";
import Store from "@/stores";

export interface IPageLayoutProps {
  children?: React.ReactNode;
  header?: React.ReactNode;
  store?: Store;
}

@inject("store")
@autobind
@observer
export default class PageLayout extends React.PureComponent<IPageLayoutProps> {
  render() {
    const {children, header, store} = this.props;
    return (
      <Layout className="PageLayout">
        <Layout.Header>{header ?? <Header />}</Layout.Header>
        {store!.alert}
        <Layout.Content>{children}</Layout.Content>
      </Layout>
    );
  }
}
